import React, { Fragment, useEffect, useState } from 'react'
import { useTranslate, useResourceContext, useResourceDefinitions, ListContextProvider, ListToolbar, useList, DateField, useRemoveFromStore, useNotify, useRedirect, } from 'react-admin'
// import { DataGrid } from '@mui/x-data-grid';
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap';
import { billingFormServices } from 'src/services/payment/billingForm/billingForm.service';
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar';
import { CardCommon } from 'src/components/uiElements';
import { setResourceProps } from 'src/helper/resourceProps';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Table, TextField, TableBody, TableCell, TableHead, TableRow, TableContainer, Button, Grid, Pagination, Stack, Accordion, AccordionSummary, Icon, Container, AccordionDetails, InputLabel, FormControl, MenuItem, Select, Skeleton, Alert } from '@mui/material'
import { paymentServices } from 'src/services/payment/Payment.service'
import { HasPermission } from 'src/helper/HasPermission';

function BillingFormList() {
	  const translate = useTranslate()
	const redirect = useRedirect()
	const [paymentTypes, setPaymentTypes] = useState([])
	const [data, setData] = useState(null)
	const [isLoading, setIsLoading] = useState(false)
	const [sort, setSort] = useState({ field: 'id', order: 'ASC' })
	const [filterShow, setFilterShow] = useState(true)
	//   const [isFilter, setIsFilter] = useState(true);
	const [filteredData, setFilteredData] = useState([])

	// Pagination
	const [page, setPage] = useState(1); // Página actual
	const [totalPages, setTotalPages] = useState(1); // Total de páginas
	const [perPage] = useState(10); // Resultados por página

	// Filters
	const [filterInputs, setFilterInputs] = useState({
		status: '',
		bussinesUnit: '',
		workUnit: '',
		user: '',
		reservation: '',
		createdAfter: '',
		createdBefore: '',
		paymentDate: '',
		id:'',
		paymentType:'',
		hasReceipt: ''
	})

	const minDate = dayjs().startOf('month')

	setResourceProps(useResourceDefinitions(), useResourceContext())

	const getPaymentTypes = async () =>{
		await paymentServices.getAllPaymentTypes().then((res)=>{
			setPaymentTypes(res)
		})
	}

	useEffect(()=>{
		getPaymentTypes()
	},[])

	useEffect(() => {
		const retrievedFilters = sessionStorage.getItem('RaStore.billingform.listParams')
		const filtersObj = retrievedFilters ? JSON.parse(retrievedFilters) :null
		if(filtersObj){
			setFilterInputs(filtersObj)
		}
		getBillingFormList(page, filtersObj ?? filterInputs); // Llamar al cargar el componente y en cambios de página
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page]);

	const getBillingFormList = async (pageNumber, filters) => {
		setIsLoading(true);
		try {
			// Crear la query con paginación y filtros
			let query = `page=${pageNumber}&limit=${perPage}`;
			// Agregar filtros a la query
			if (filters.status) query += `&status=${filters.status}`;
			if (filters.reservation) query += `&reservation_number=${filters.reservation}`;
			if (filters.user) query += `&user_name=${filters.user}`;
			if (filters.bussinesUnit) query += `&business_unit_name=${filters.bussinesUnit}`;
			if (filters.workUnit) query += `&work_unit_name=${filters.workUnit}`;
			if (filters.createdAfter) query += `&create_at_after=${dayjs(filters.createdAfter).format('YYYY-MM-DD')}`;
			if (filters.createdBefore) query += `&create_at_before=${dayjs(filters.createdBefore).format('YYYY-MM-DD')}`;
			if (filters.paymentDate) query += `&payment_date=${dayjs(filters.paymentDate).format('YYYY-MM-DD')}`;
			if (filters.id) query += `&id=${filters.id}`;
			if (filters.paymentType) query += `&payment_type=${filters.paymentType}`;
			if (filters.hasReceipt === true || filters.hasReceipt === false) query += `&has_receipt=${filters.hasReceipt}`;

			// Llamada a la API
			const billingList = await billingFormServices.getBillingFormList(query);
			const filtersObj = {
				status:filters.status ?? null,
				reservation:filters.reservation ?? null,
				user:filters.user ?? null,
				bussinesUnit:filters.bussinesUnit ?? null,
				workUnit:filters.workUnit ?? null,
				createdAfter:filters.createdAfter ?? null,
				createdBefore:filters.createdBefore ?? null,
				paymentDate:filters.paymentDate ?? null,
				id:filters.id ?? null,
				paymentType:filters.paymentType ?? null,
				hasReceipt:filters.hasReceipt ?? null,
			}

			sessionStorage.setItem('RaStore.billingform.listParams', JSON.stringify(filtersObj))
			setData(billingList.billingforms);
			setTotalPages(billingList.total_pages); // Actualizar total de páginas
		} catch (error) {
			console.error('Error fetching billing forms: ', error);
			setData([]);
		} finally {
			setIsLoading(false);
		}
	};

	// Start Pagination
	const handlePageChange = (event, value) => {
		setPage(value); // Actualiza la página actual
		getBillingFormList(value, filterInputs); // Realiza una nueva solicitud a la API
	};
	// End Pagination

	// Start Filter
	const handleClickApplyFilters = () => {
		setPage(1); // Reiniciar a la página 1
		getBillingFormList(1, filterInputs); // Llamar a la API con los filtros y reiniciar la paginación
	};
	const handleClickClearFilters = () => {
		const clearedFilters = {
			status: '',
			bussinesUnit: '',
			workUnit: '',
			user: '',
			reservation: '',
			createdAfter: null,
			createdBefore: null,
			paymentDate: null
		};
		setFilterInputs(clearedFilters);
		setPage(1);
		getBillingFormList(1, clearedFilters); // Cargar datos sin filtros
	};

	// End Filter

	// Función para manejar los cambios en los inputs de los filtros
	const onChangeField = (field, value) => {
		setFilterInputs((prevFilters) => ({
			...prevFilters,
			[field]: value,
		}));
	};

	function obtenerTiposDePagoUnicos(payments) {
		const tiposDePagoUnicos = new Set();
		payments.forEach(payment => {
			tiposDePagoUnicos.add(payment.payment_type);
		});
		return Array.from(tiposDePagoUnicos).join(", ");
	}

	return (
		<Container className='pageListContainer'>
			<Grid container spacing={3} className='pageListCard'>
				<Grid item sm={12}>
<Alert severity='warning' sx={{ width: '100%', mb: 6 }}>
						Si estás reportando el <strong>pago de una reserva con cancelación próxima o inmediata</strong>, te recomendamos <strong>dar aviso al vendedor</strong> correspondiente para garantizar el servicio. Este módulo no envía notificaciones automáticas a los vendedores.
					</Alert>
				</Grid>
				<Grid item sm={12}>
					<Accordion className='collapsibleCard filterContainer' defaultExpanded={filterShow}>
						<AccordionSummary aria-controls='filter-content' id='filter-header' className='filterHeader'>
							<span className='titleFilter'>
								<span className='text'>{translate('ra.title.filters')}</span> <Icon className='icon'>expand_more</Icon>{' '}
							</span>
						</AccordionSummary>
						<AccordionDetails className='filterBody'>
							<Grid container spacing={1}>
								<Grid item md={11} lg={11} xs={11}>
									<Grid container spacing={1}>

										{/* Start Filter Form */}
										<EditInputsWrap label={translate('ra.field.state')} xs={12} sm={6} md={3} lg={3} xl={2}>
											<FormControl fullWidth variant='outlined' size='small'>
												<InputLabel></InputLabel>
												<Select
													value={filterInputs.status || ''}
													onChange={(e) => onChangeField('status', e.target.value)}
													displayEmpty
												>
													<MenuItem key={1} value={''} disabled={true}>
														<em>{translate('ra.field.select_all')}</em>
													</MenuItem>
													<MenuItem key={1} value={'ingresado'}>
													{translate('ra.status.status_entered')}
													</MenuItem>
													<MenuItem key={2} value={'en revision'}>
													{translate('ra.status.status_review')}
													</MenuItem>
													<MenuItem key={2} value={'rechazado'}>
													{translate('ra.status.status_rejected')}
													</MenuItem>
													<MenuItem key={2} value={'aprobado'}>
													{translate('ra.status.status_aproved')}
													</MenuItem>
												</Select>
											</FormControl>
										</EditInputsWrap>
										<EditInputsWrap label={translate('ra.field.reserve')} xs={12} sm={6} md={3} lg={3} xl={2}>
											<TextField
												size='small'
												placeholder={translate('ra.field.select_all')}
												fullWidth
												value={filterInputs.reservation || ''}
												onChange={(e) => onChangeField('reservation', e.target.value)}
											/>
										</EditInputsWrap>
										<EditInputsWrap label={translate('ra.field.user')} xs={12} sm={6} md={3} lg={3} xl={2}>
											<TextField
												size='small'
												fullWidth
												placeholder={translate('ra.field.select_all')}
												value={filterInputs.user || ''}
												onChange={(e) => onChangeField('user', e.target.value)}
											/>
										</EditInputsWrap>
										<HasPermission permission='filter' resource={'billingform'}>
											<EditInputsWrap label={translate('ra.entity.business-unit')} xs={12} sm={6} md={3} lg={3} xl={2}>
												<TextField
													size='small'
													fullWidth
													placeholder={translate('ra.field.select_all')}
													value={filterInputs.bussinesUnit || ''}
													onChange={(e) => onChangeField('bussinesUnit', e.target.value)}
												/>
											</EditInputsWrap>
											<EditInputsWrap label={translate('ra.entity.work-unit')} xs={12} sm={6} md={3} lg={3} xl={2}>
												<TextField
													size='small'
													fullWidth
													placeholder={translate('ra.field.select_all')}
													value={filterInputs.workUnit || ''}
													onChange={(e) => onChangeField('workUnit', e.target.value)}
												/>
											</EditInputsWrap>
										</HasPermission>
										<EditInputsWrap label={translate('ra.field.created_from')} md={3} lg={3} xs={12}>
											<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
												<DatePicker
													disableFuture={true}
													value={filterInputs.createdAfter || null}
													onChange={(date) => onChangeField('createdAfter', date)}
													renderInput={(params) => (
														<TextField {...params} fullWidth variant='outlined' size='small' error={false} />
													)}
												/>
											</LocalizationProvider>
										</EditInputsWrap>
										<EditInputsWrap label={translate('ra.field.created_until')} md={3} lg={3} xs={12}>
											<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
												<DatePicker
													disableFuture={true}
													value={filterInputs.createdBefore || null}
													onChange={(date) => onChangeField('createdBefore', date)}
													renderInput={(params) => (
														<TextField {...params} fullWidth variant='outlined' size='small' error={false} />
													)}
												/>
											</LocalizationProvider>
										</EditInputsWrap>
										<EditInputsWrap label={translate('ra.field.payment_date')} md={3} lg={3} xs={12}>
											<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
												<DatePicker
													disableFuture={true}
													value={filterInputs.paymentDate || null}
													onChange={(date) => onChangeField('paymentDate', date)}
													renderInput={(params) => (
														<TextField {...params} fullWidth variant='outlined' size='small' error={false} />
													)}
												/>
											</LocalizationProvider>
										</EditInputsWrap>
										<EditInputsWrap label={translate('ra.field.id')} md={3} lg={3} xs={12}>
											<TextField
												size='small'
												fullWidth
												type='number'
												placeholder={translate('ra.field.id')}
												value={filterInputs.id || ''}
												onChange={(e) => onChangeField('id', e.target.value)}
											/>
										</EditInputsWrap>
										<EditInputsWrap label={translate('ra.field.payment_type')} md={3} lg={3} xs={12}>
											<FormControl fullWidth variant='outlined' size='small'>
												<InputLabel></InputLabel>
												<Select
													value={filterInputs.paymentType || ''}
													onChange={(e) => onChangeField('paymentType', e.target.value)}
													displayEmpty
												>
													<MenuItem key={0} value={''} disabled={true}>
														<em>{translate('ra.field.select_all')}</em>
													</MenuItem>
													{paymentTypes.map((type, index)=>(
														<MenuItem key={index + 1} value={type.long_name.toLowerCase()}>
															{type.long_name}
														</MenuItem>
													))
													}
													
												</Select>
											</FormControl>
										</EditInputsWrap>
										<HasPermission resource={'billingform'} permission='filter_receipt'>
											<EditInputsWrap label={translate('ra.field.has_receipt')} md={3} lg={3} xs={12}>
												<FormControl fullWidth variant='outlined' size='small'>
													<InputLabel></InputLabel>
													<Select
														value={filterInputs.hasReceipt}
														onChange={(e) => onChangeField('hasReceipt', e.target.value)}
														displayEmpty
													>
														<MenuItem key={0} value={null}>
															{'-'}
														</MenuItem>
														<MenuItem key={1} value={true}>
															{translate('ra.message.yes')}
														</MenuItem>
														<MenuItem key={2} value={false}>
															{translate('ra.message.no')}
														</MenuItem>
														
													</Select>
												</FormControl>
											</EditInputsWrap>
										</HasPermission>
										{/* End Filter Form */}

									</Grid>
								</Grid>
								<Grid item md={1} lg={1} xs={1}>
									<Button onClick={() => { handleClickApplyFilters() }} variant='contained' color='primary' startIcon={<Icon>filter_list</Icon>} className='btnFilter'>
									{translate('ra.action.filter')}
									</Button>
									<Button onClick={() => { handleClickClearFilters() }} color='primary' startIcon={<Icon>clear</Icon>}>
									{translate('ra.action.clear')}
									</Button>
								</Grid>
							</Grid>
						</AccordionDetails>
					</Accordion>
				</Grid>
				<Grid item sm={12}>
					<TableContainer className='billingFormListTable'>
						<Table sx={{ minWidth: 650 }} aria-label='simple table' loading={true}>
							<TableHead className='tableHeader'>
								<TableRow>
									<TableCell align='center'>Id</TableCell>
									<TableCell align='center'>{translate('ra.field.status')}</TableCell>
									<TableCell align='center'>{translate('ra.field.user')}</TableCell>
									<TableCell align='center'>{translate('ra.field.business_unit')}</TableCell>
									<TableCell align='center'>{translate('ra.field.payment_type')}</TableCell>
									<TableCell align='center'>{translate('ra.field.create_at')}</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{
									isLoading ?
										<>
											{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row) => (
												<TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} hover={true}>
													<TableCell align='center' colSpan={6}>
														<Skeleton variant="rectangular" height={20} />
													</TableCell>
												</TableRow>
											))}
										</>
										:
										<>
											{data?.length > 0 ?
												<Fragment>
													{data?.map((row) => (
														<TableRow key={row.id}
															sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer' }}
															hover={true}
															onClick={() => { redirect(`/billingform/${row.id}/show`) }}>
															<TableCell align='center'>
																{row.id}{' '}
															</TableCell>
															<TableCell align='center'>{row.status}</TableCell>
															<TableCell align='center'>{row.user_info.name} {row.user_info.surname}</TableCell>
															<TableCell align='center'>{row.business_unit_info.long_name}</TableCell>
															<TableCell align='center'>{obtenerTiposDePagoUnicos(row.payments)}</TableCell>
															<TableCell align='center'>
																{dayjs(row.create_at).format('DD-MM-YYYY')}
															</TableCell>
														</TableRow>
													))}
												</Fragment>
												:
												<Fragment>
													<TableRow >
														<TableCell align='center' colSpan={6}>
															<div style={{ color: '#e39505' }}>({translate('ra.navigation.no_results_filters')})</div>
														</TableCell>
													</TableRow>
												</Fragment>

											}
										</>
								}
							</TableBody>
						</Table>

						<Stack spacing={2} direction="row" alignItems="flex-end" justifyContent="flex-end" className='bloqPagination'>
							{data?.length > 0 &&
								<Fragment>
									<span className='paginationPages'> {translate('ra.navigation.page_range_info_billingform', { page, totalPages })}</span>
									<Pagination
										count={totalPages} // Número total de páginas
										page={page} // Página actual
										onChange={handlePageChange} // Callback cuando cambia la página
										color='primary' />
								</Fragment>
							}
						</Stack>
					</TableContainer>
				</Grid>
			</Grid>
		</Container>
	)
}

export default BillingFormList